import React, { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import moment from 'moment-timezone';
import { Modal, Box, Typography, Button, TextField, MenuItem, Select, InputLabel, FormControl, FormHelperText, IconButton, Divider, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from '@mui/material';

import AlertComponent from './AlertComponent';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';

const LoanForm = ({ user, selectedDate, closeModal, isOpen, selectedEvent, onAlert }) => {
  const [isEditing, setIsEditing] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [loanNumber, setLoanNumber] = useState(selectedEvent && selectedEvent.extendedProps ? selectedEvent.extendedProps.loanNumber : '');
  const [alert, setAlert] = useState({ open: false, message: '', type: '' });
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const pdfjsVersion = '3.11.174';
  const [clientName, setClientName] = useState(selectedEvent && selectedEvent.extendedProps ? selectedEvent.extendedProps.clientName : '');
  const [clientEmail, setClientEmail] = useState(selectedEvent && selectedEvent.extendedProps ? selectedEvent.extendedProps.clientEmail : '');
  const [startDate, setStartDate] = useState(selectedEvent ? moment(selectedEvent.start).tz('America/Puerto_Rico').format('YYYY-MM-DD') : '');
  const [startTime, setStartTime] = useState(selectedEvent ? moment(selectedEvent.start).tz('America/Puerto_Rico').format('HH:mm') : '');
  const [endDate, setEndDate] = useState(selectedEvent ? moment(selectedEvent.start).tz('America/Puerto_Rico').format('YYYY-MM-DD') : '');
  const [endTime, setEndTime] = useState(selectedEvent ? moment(selectedEvent.start).tz('America/Puerto_Rico').format('HH:mm') : '');
  const [contribution, setContribution] = useState(selectedEvent && selectedEvent.extendedProps ? selectedEvent.extendedProps.contribution : '');
  const [file, setFile] = useState(null);

  const handleEdit = () => setIsEditing(true);
  const handleCancelEdit = () => setIsEditing(false);

  useEffect(() => {
    if (selectedDate) {
      const date = moment(selectedDate).tz('America/Puerto_Rico');
      if (!selectedEvent || !selectedEvent.id) {
        setStartDate(date.format('YYYY-MM-DD'));
        const currentTime = moment().tz('America/Puerto_Rico');
        setStartTime(currentTime.format('HH:mm'));
        const endTime = moment(currentTime).add(30, 'minutes');
        setEndDate(date.format('YYYY-MM-DD'));
        setEndTime(endTime.format('HH:mm'));
        setIsEditing(true);
      }
    }
  }, [selectedDate, selectedEvent]);
    
  const [abogados, setAbogados] = useState([]);
  const [abogadosCompraVenta, setAbogadosCompraVenta] = useState([]);
  const [procesadoras, setProcesadoras] = useState([]);
  const [originadores, setOriginadores] = useState([]);
  const [selectedAbogado, setSelectedAbogado] = useState(selectedEvent && selectedEvent.extendedProps ? selectedEvent.extendedProps.abogado : '');
  const [selectedAbogadoCompraVenta, setSelectedAbogadoCompraVenta] = useState(selectedEvent && selectedEvent.extendedProps ? selectedEvent.extendedProps.abogadoCompraVenta : '');
  const [selectedProcesadora, setSelectedProcesadora] = useState(selectedEvent && selectedEvent.extendedProps ? selectedEvent.extendedProps.procesadora : '');
  const [selectedOriginador, setSelectedOriginador] = useState(selectedEvent && selectedEvent.extendedProps ? selectedEvent.extendedProps.originador : '');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const abogadosSnapshot = await getDocs(collection(db, 'abogados'));
        const abogadosCompraVentaSnapshot = await getDocs(collection(db, 'abogadosCompraVenta'));
        const procesadorasSnapshot = await getDocs(collection(db, 'procesadoras'));
        const originadoresSnapshot = await getDocs(collection(db, 'originadores'));

        setAbogados(abogadosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        setAbogadosCompraVenta(abogadosCompraVentaSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        setProcesadoras(procesadorasSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        setOriginadores(originadoresSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
          } catch (error) {
            onAlert('Error al cargar los datos. Por favor, inténtelo de nuevo.', 'error');
          }
    };

    fetchData();
  }, [onAlert]);

  const [pdfLink, setPdfLink] = useState(null);

  useEffect(() => {
    if (selectedEvent && selectedEvent.extendedProps && selectedEvent.extendedProps.file) {
      setPdfLink(selectedEvent.extendedProps.file);
    }
  }, [selectedEvent]);

const handleSubmit = async (e) => {
    e.preventDefault();

    let fileData = null;

    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        fileData = reader.result;

        const event = {
          title: `Préstamo: ${loanNumber} - ${clientName}`,
          start: new Date(`${startDate}T${startTime}`),
          end:  new Date(`${startDate}T${startTime}`),
          extendedProps: {
            loanNumber,
            clientName,
            clientEmail,
            contribution,
            abogado: selectedAbogado,
            abogadoCompraVenta: selectedAbogadoCompraVenta,
            procesadora: selectedProcesadora,
            originador: selectedOriginador,
            file: fileData
          }
        };

        if (selectedEvent && selectedEvent.id) {
          const eventDoc = doc(db, 'events', selectedEvent.id);
          try {
            await updateDoc(eventDoc, event);
            setAlert({ open: true, message: 'Evento actualizado exitosamente', type: 'success' });
          } catch (error) {
            console.error("Error updating event: ", error);
            setAlert({ open: true, message: "Error al actualizar el evento. Por favor, inténtelo de nuevo.", type: "error" });
          }
      } else {
          try {
            await addDoc(collection(db, 'events'), event);
            setAlert({ open: true, message: 'Evento creado exitosamente', type: 'success' });
          } catch (error) {
            setAlert({ open: true, message: "Error al crear el evento. Por favor, inténtelo de nuevo.", type: "error" });
      }
        }
        closeModal();
      };
      reader.readAsDataURL(file);
    } else {
      const event = {
        title: `Préstamo: ${loanNumber} - ${clientName}`,
        start: new Date(`${startDate}T${startTime}`),
        end: new Date(`${startDate}T${startTime}`),
        extendedProps: {
          loanNumber,
          clientName,
          clientEmail,
          contribution,
          abogado: selectedAbogado,
          abogadoCompraVenta: selectedAbogadoCompraVenta,
          procesadora: selectedProcesadora,
          originador: selectedOriginador,
          file: null
        }
      };

      if (selectedEvent && selectedEvent.id) {
        const eventDoc = doc(db, 'events', selectedEvent.id);
        await updateDoc(eventDoc, event);
        onAlert('Evento actualizado exitosamente', 'success');
      } else {
        await addDoc(collection(db, 'events'), event);
        onAlert('Evento creado exitosamente', 'success');
      }

        closeModal();
    }
  };

  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleDelete = () => {
    setConfirmDelete(true);
  };

  const confirmDeleteEvent = async () => {
    if (selectedEvent) {
      const eventDoc = doc(db, 'events', selectedEvent.id);
      try {
        await deleteDoc(eventDoc);
        
      onAlert('Evento eliminado exitosamente', 'success');
      } catch (error) {
        onAlert('Error al eliminar el evento.', 'error');
      }
        closeModal();
    }
    setConfirmDelete(false);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setFile(selectedFile);
    } else {
      setAlert({ open: true, message: 'Por favor, suba un archivo PDF.', type: 'warning' });
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && droppedFile.type === 'application/pdf') {
      setFile(droppedFile);
    } else {
      setAlert({ open: true, message: 'Por favor, arrastra un archivo PDF válido.', type: 'warning' });
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };


  const [isModified, setIsModified] = useState(false);

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    setIsModified(true);
  };

  const handleClose = () => {
    if (isModified) {
      setConfirmClose(true);
    } else {
        closeModal();
    }
  };

return (
    <Container>
      <Modal open={isOpen} onClose={handleClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '95%', sm: 'sm', md: 'md' }, // Ajuste de anchura responsive
        maxWidth: 'md', // Anchura máxima para pantallas grandes
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: { xs: 2, sm: 3, md: 4 }, // Padding responsive
        borderRadius: 2,
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <Typography variant="h6" component="h2" align="center" sx={{ mb: 3 }}>
        Detalles del Préstamo
        </Typography>{!isEditing ? (
            
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography><strong>Número de Préstamo:</strong></Typography>
            </Grid>
              <Divider />
            <Grid item xs={6}>
              <Typography>{loanNumber}</Typography>
            </Grid>
              <Divider />
            <Grid item xs={6}>
              <Typography><strong>Nombre del Cliente:</strong></Typography>
            </Grid>
              <Divider />
            <Grid item xs={6}>
              <Typography>{clientName}</Typography>
            </Grid>
              <Divider />
            <Grid item xs={6}>
              <Typography><strong>Fecha de Cierre:</strong></Typography>
            </Grid>
              <Divider />
            <Grid item xs={6}>
              <Typography>{startDate}</Typography>
            </Grid>
              <Divider />
            <Grid item xs={6}>
              <Typography><strong>Hora de Cierre:</strong></Typography>
            </Grid>
              <Divider />
            <Grid item xs={6}>
              <Typography>{startTime}</Typography>
            </Grid>
              <Divider />
            <Grid item xs={6}>
              <Typography><strong>Abogado de Hipoteca:</strong></Typography>
            </Grid>
              <Divider />
            <Grid item xs={6}>
              <Typography>{abogados.find(a => a.id === selectedAbogado)?.name}</Typography>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-around', mt: 2 }}>
            {user.role !== 'readonly' && (
                <>
              <Button startIcon={<EditIcon />} onClick={handleEdit} variant="contained">Editar</Button>
              </>
              )}
              <Button startIcon={<CloseIcon />} onClick={closeModal} variant="outlined">Cerrar</Button>
            </Grid>
          </Grid>
        </Box>
          ) : (

        <form onSubmit={handleSubmit}>
          <TextField
            label="Número de Préstamo"
            type="text"
            value={loanNumber}
            onChange={handleInputChange(setLoanNumber)}
            required
            fullWidth
            margin="normal"
            inputProps={{ pattern: '\\d{1,20}', title: 'Solo números y máximo de 20 caracteres.' }}
          />

          <TextField
            label="Nombre del Cliente"
            type="text"
            value={clientName}
            onChange={handleInputChange(setClientName)}
            required
            fullWidth
            margin="normal"
            inputProps={{ maxLength: 100 }}
          />

          <TextField
            label="Email del Cliente"
            type="email"
            value={clientEmail}
            onChange={handleInputChange(setClientEmail)}
            fullWidth
            margin="normal"
          />

          <TextField
            label="Fecha de Cierre"
            type="date"
            value={startDate}
            onChange={handleInputChange(setStartDate)}
            required
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            label="Hora de Cierre"
            type="time"
            value={startTime}
            onChange={handleInputChange(setStartTime)}
            required
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            label="Aportación"
            type="number"
            value={contribution}
            onChange={handleInputChange(setContribution)}
            step="0.01"
            fullWidth
            margin="normal"
          />

          <FormControl fullWidth margin="normal" required>
            <InputLabel>Abogado de Hipoteca</InputLabel>
            <Select
              value={abogados.some(a => a.id === selectedAbogado) ? selectedAbogado : ''} 
              onChange={handleInputChange(setSelectedAbogado)}
              label="Abogado de Hipoteca"
            >
              {abogados.map(abogado => (
                <MenuItem key={abogado.id} value={abogado.id}>
                  {abogado.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>Selecciona un abogado de la lista</FormHelperText>
          </FormControl>



          <FormControl fullWidth margin="normal">
            <InputLabel>Abogado de Compraventa</InputLabel>
            <Select
              value={abogadosCompraVenta.some(a => a.id === selectedAbogadoCompraVenta) ? selectedAbogadoCompraVenta : ''} 
              onChange={handleInputChange(setSelectedAbogadoCompraVenta)}
              label="Abogado de Compraventa"
            >
              {abogadosCompraVenta.map(abogadoCompraVenta => (
                <MenuItem key={abogadoCompraVenta.id} value={abogadoCompraVenta.id}>
                  {abogadoCompraVenta.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal">
            <InputLabel>Procesadora</InputLabel>
            <Select
              value={selectedProcesadora}
              onChange={handleInputChange(setSelectedProcesadora)}
            >
              <MenuItem value="">
                <em>Seleccione una procesadora</em>
              </MenuItem>
              {procesadoras.map(procesadora => (
                <MenuItem key={procesadora.id} value={procesadora.id}>
                  {procesadora.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal">
            <InputLabel>Originador</InputLabel>
            <Select
              value={selectedOriginador}
              onChange={handleInputChange(setSelectedOriginador)}
            >
              <MenuItem value="">
                <em>Seleccione un originador</em>
              </MenuItem>
              {originadores.map(originador => (
                <MenuItem key={originador.id} value={originador.id}>
                  {originador.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal">
          <InputLabel shrink htmlFor="upload-file">Closing Disclosure (PDF)</InputLabel>
          <Box
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            sx={{
              border: '2px dashed #007BFF',
              padding: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              backgroundColor: '#f9f9f9',
              marginTop: '20px',
              '&:hover': {
                backgroundColor: '#e6f7ff',
                borderColor: '#0056b3'
              }
            }}
          >
            <input
              id="upload-file"
              type="file"
              onChange={handleFileChange}
              accept="application/pdf"
              style={{ display: 'none' }}
            />
            <label htmlFor="upload-file" style={{ width: '100%', textAlign: 'center' }}>
              {file ? file.name : 'Haz clic o arrastra un archivo PDF aquí'}
            </label>
          </Box>
            
          {pdfLink && ( 
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <Typography variant="body2">
        <Button variant="contained" color="primary" onClick={() => setPdfModalOpen(true)}>
          Ver PDF
        </Button>
        <Modal open={pdfModalOpen} onClose={() => setPdfModalOpen(false)}>
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            height: '85%',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            overflow: 'auto',
            border: '2px solid #000',
          }}>
            
            <IconButton 
          onClick={() => setPdfModalOpen(false)} 
          color="secondary" 
          sx={{ position: 'absolute', top: 0, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}>
              <Viewer fileUrl={pdfLink} plugins={[defaultLayoutPluginInstance]} />
            </Worker>
            
          </Box>
        </Modal>
              </Typography>
            </Box>
          )}
          </FormControl>
          {/* Separador */}
          {/* Separador */}
          <Box sx={{ height: 24 }} />
          {/* Linea separadora */}
          <Divider sx={{ mb: 2 }} />
          {/* Separador */}
          <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 4 }}>
            <Button onClick={handleClose} variant="outlined" color="inherit" startIcon={<CloseIcon />}>
              Cancelar
            </Button>
            {selectedEvent.id && (
              <Button color="error" variant="contained" onClick={handleDelete} startIcon={<DeleteIcon />}>
                Eliminar
              </Button>
            )}
            <Button type="submit" color="primary" variant="contained" startIcon={<SaveIcon />}>
              Guardar
            </Button>
          </Box>
        </form>
        )}
      </Box>
      </Modal>
      <AlertComponent
        open={alert.open}
        message={alert.message}
        type={alert.type}
        handleClose={() => setAlert({ ...alert, open: false })}
      />
      <Dialog
        open={confirmClose}
        onClose={() => setConfirmClose(false)}
      >
        <DialogTitle>Confirmación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Estás seguro de que deseas cerrar? Se perderán los datos no guardados.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmClose(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => {
            closeModal();
            setConfirmClose(false);
          }} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmDelete}
        onClose={() => setConfirmDelete(false)}
      >
        <DialogTitle>Confirmación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Estás seguro de que deseas eliminar este evento?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDelete(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={confirmDeleteEvent} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default LoanForm;
